module.exports = __webpack_public_path__ + "static/media/Presentation Miysis 2019.3a5180d3.pdf";